import React from 'react';
import { Input } from 'antd';
const { TextArea: TextAreaAntd } = Input;
const TextArea = props => <TextAreaAntd rows={4} {...props} />;
export default TextArea;
